import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, LoadingController, AlertController, IonInput } from '@ionic/angular';
import { CartService } from '../../services/cart.service';
import { APIService } from '../../services/api.service';
import { Decimal } from 'decimal.js';

@Component({
    selector: 'app-sell-gift-voucher',
    templateUrl: './sell-gift-voucher.page.html',
    styleUrls: ['./sell-gift-voucher.page.scss'],
})
export class SellGiftVoucherPage implements OnInit {

    @ViewChild('amount_input', { static: false }) amount_input: IonInput;

    code = null;
    amount = null;
    spinner = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public loadingController: LoadingController,
        private apiService: APIService,
        private cartService: CartService
    ) { }

    ngOnInit() {
        this.generateCode();
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        setTimeout(() => {
            if(this.amount_input) {
                this.amount_input.setFocus();
            }
        }, 200);
    }

    generateCode() {
        let numbers = "0123456789";
        let length = 16;
        let code = '';
        for (let i = 0; i < length; i++) {
            let random_number = Math.floor(Math.random() * numbers.length);
            code += numbers.substring(random_number, random_number + 1);
        }
        this.code = code;
    }

    close() {
        this.modalController.dismiss();
    }

    addToCart() {
        this.cartService.addGiftVoucherItem(this.code,this.amount).then(() => {
            this.modalController.dismiss();
        });
    }

    validateInput() {
        let validated = true;
        this.presentSpinner("Validating voucher").then(async () => {
            if (this.code == null || this.code.trim() === "") {
                validated = false;
                this.presentAlert("Problem", "Please enter a voucher code", "");
            }
            else {
                await this.apiService.getGiftVoucher(this.code, {}).then((gift_voucher: any) => {
                    if (gift_voucher) {
                        validated = false;
                        this.presentAlert("Problem", "Already exists", "This gift voucher code already exists, please use a different code.");
                    }
                })
                .catch((error: any) => {
                // We expect a 401 (not found) here, i.e. if a voucher is not found then it is unique and can be created.
                    if (error) {
                        if(error.status === 400) {
                            validated = false;
                            this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to check if this voucher exists.");
                        } else if(error.status === 403) {
                            validated = false;
                            this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to retrieve a gift voucher.");
                        } else if(error.status === 0) {
                            validated = false;
                            this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to check this voucher at this time.");
                        }
                    }
                });
            }

            let regex = /^-?\d*\.?\d*$/;

            // Catch nulls
            if (this.amount == null || this.amount.trim() === "") {
                validated = false;
                this.spinner.dismiss();
                this.presentAlert("Problem", "No amount entered", "");
            }
            // Catch negatives
            else if (this.amount <= 0) {
                validated = false;
                this.spinner.dismiss();
                this.presentAlert("Problem", "Amount must above zero", "");
            }
            // Catch letters or symbols or multiple dps
            else if (!regex.test(String(this.amount).toLowerCase())) {
                validated = false;
                this.spinner.dismiss();
                this.presentAlert("Problem", "Invalid amount", "");
            }
            else {
                // ensure 2dp
                this.amount = Number(new Decimal(this.amount).toDecimalPlaces(2));
            }

            if (validated) {
                this.spinner.dismiss();
                this.addToCart();
            }
            else {
                this.spinner.dismiss();
            }
        });
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
